// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1vxQF","item":"PaymentsMobile_item__1dPqY","label":"PaymentsMobile_label__1zEB1","amount":"PaymentsMobile_amount__vFSBx"};